import React, { Component } from 'react';
import Routes from './routes'
import '../node_modules/font-awesome/css/font-awesome.min.css'

class App extends Component {

  render() {
    return (
      <div className="App fullHeight">
        <Routes />
      </div>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js